import React from 'react';
import { useTranslations } from 'next-intl';

function MyDownloads() {
  const t = useTranslations('Account');

  return (
    <div>
      <h2>{t('my_downloads')}</h2>
      <p>Here you can access your downloadable products.</p>
    </div>
  );
}

export default MyDownloads;
